export const EQUIPMENT_CONDITION_NEW = 'NEUF'
export const EQUIPMENT_CONDITION_USED = 'OCCASION'
